<template>
  <q-page padding>
    <PageHeader
      title="Definição de Turnos"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div class="q-ml-md">
      <div class="q-mt-lg">
        <div
          style="font-size: 16px"
          class="q-mb-lg text-brand-1 text-weight-medium"
        >
          <span>Utilize os campos para definir novos turnos.</span>
        </div>
        <section
          class="row col-12 q-mt-sm q-gutter-sm text-brand-1 text-weight-bold"
        >
          <div class="col-md-3">
            <div class="q-ml-sm">Unidade</div>
            <lista-unidades-select v-model="unidade"></lista-unidades-select>
          </div>

          <div class="col-md-3">
            <div class="q-ml-sm">Descrição:</div>
            <q-input outlined dense v-model="descricao" placeholder="Descrição">
            </q-input>
          </div>

          <div class="col-md">
            <div class="q-ml-sm">Hora Inicial:</div>
            <q-input outlined dense v-model="dataInicial" mask="time">
              <template v-slot:append>
                <q-icon name="access_time" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-time v-model="dataInicial">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-time>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div class="col-md">
            <div class="q-ml-sm">Hora Final:</div>
            <q-input outlined dense v-model="dataFinal" mask="time">
              <template v-slot:append>
                <q-icon name="access_time" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-time v-model="dataFinal">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-time>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-md">
            <q-btn
              icon="add"
              label="Adicionar"
              color="positive"
              class="q-mt-lg"
              @click="criarTurno"
            />
          </div>
        </section>
      </div>
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      :rows="rows"
      :columns="columns"
      dense
      color="primary"
      class="tabela-tamanho-fixo q-mt-lg"
      :loading="disable"
      title-class="text-brand-5 text-weight-bold"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-solicitante_nome="props">
        <q-td>
          <div class="row">
            <span>
              {{ props.row.solicitante_nome }}
            </span>
            <span> ( {{ props.row.solicitante_matricula }}) </span>
          </div>
        </q-td>
      </template>
      <template #body-cell-cost_center_code="props">
        <q-td>
          <div class="row">
            <span>
              {{ props.row.cost_center_code }}
            </span>
            <span class="row"> ({{ props.row.cost_center_name }}) </span>
          </div>
        </q-td>
      </template>
      <template #body-cell-fornecedor="props">
        <q-td>
          <span class="text-brand-5 text-weight-bold">{{
            props.row?.provider?.business_name
          }}</span>
        </q-td>
      </template>
      <template #body-cell-receber="props">
        <q-td>
          <q-btn
            :disable="props.row.products.length == 0"
            round
            :color="props.row.products.length == 0 ? 'grey' : 'positive'"
            icon="sym_o_done_outline"
            flat
            @click="rota('compras-receber', props.row.id)"
          />
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            v-if="props"
            @click="(confirmacao = true), (deleteID = props.row.id)"
            icon="sym_o_delete"
            round
            color="negative"
            flat
          />
        </q-td>
      </template>
      <template #body-cell-imprimir="props">
        <q-td>
          <q-btn
            @click="rota('compras-imprimir-pedidos', props.row.id)"
            icon="sym_o_print"
            round
            color="black"
            flat
          />
        </q-td>
      </template>
      <template #body-cell-editar="props">
        <q-td>
          <q-btn
            @click="rota('compras-editar', props.row.id)"
            icon="sym_o_edit"
            round
            color="primary"
            flat
          />
        </q-td>
      </template>
    </q-table>
    <!--<div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>-->
    <dialog-confirm
      mensagem="Tem certeza que deseja continuar?"
      :exibir="confirmacao"
      @resultado="deletar"
    >
    </dialog-confirm>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "Unidade",
    field: (row) => row.vendor?.name,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "description",
    label: "Descrição",
    field: "description",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "start_time",
    label: "Hora Inicial",
    field: "start_time",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "finish_time",
    label: "Hora Final",
    field: "finish_time",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogConfirm from "../components/DialogConfirm.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, DialogConfirm, PageHeader },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const dataFinal = ref("");
    const confirmacao = ref(false);
    const deleteID = ref(null);
    const dataInicial = ref("");
    const unidade = ref();
    const descricao = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        const response = await store.dispatch("office/listarTurnos", {
          vendor_id: store.state.org.unidadeData.id,
        });

        rows.value = response.data.results;

        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const deletar = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          await store.dispatch("office/deletarTurno", {
            id: deleteID.value,
          });

          $q.notify({
            message: "Turno Deletado com sucesso!",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados();
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro a o deletar Turno",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const criarTurno = async () => {
      try {
        await store.dispatch("office/criarTurno", {
          vendor_id: store.state.org.unidadeData.id,
          description: descricao.value,
          finish_time: dataFinal.value,
          start_time: dataInicial.value,
        });

        getDados();
        descricao.value = "";
        dataFinal.value = "";
        dataInicial.value = "";
        $q.notify({
          message: "Turno Criado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      descricao,
      dataFinal,
      criarTurno,
      dataInicial,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },

      confirmacao,
      status,
      deleteID,
      deletar,

      unidade,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
.no-wrap {
  flex-wrap: nowrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
.colorHeaderTabela {
  background-color: #d9effc;
}
</style>
